<template>
  <div class="container" :class="containerClass" :style="{ backgroundImage: currentStep >= 2 ? `url(${bg1})` : '' }">
    <!-- Loading界面 -->
    <Transition name="fade">
      <div v-if="isLoading" class="loading-overlay">
        <!-- 顶部背景图 -->
        <div class="header-bg">
          <div class="header-content">
            <div class="logo-section">
              <img
                src="../assets/images/logo.png"
                alt="logo"
                class="logo-image"
              />
            </div>
          </div>
        </div>
        <div class="loading-content">
          <div class="loading-spinner">
            <Spinner name="ball-clip-rotate-multiple" color="#d2c4ff" />
            <img
              :src="avatarUrl"
              alt="loading"
              class="loading-image"
            />
          </div>
          <p class="loading-text">正在生成专属卡片</p>
          <p class="loading-hint">
            {{ selectedCity?.name || "加油！" }} ·
            {{ selectedCity?.slogan || "加油！" }}
          </p>
          <div class="loading-dots">
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
            <span class="dot"></span>
          </div>
        </div>
      </div>
    </Transition>

    <div class="all-content" v-if="!isLoading">
      
      <!-- 顶部背景图 -->
      <div class="header-bg">
        <div class="header-content">
          <div class="logo-section">
            <img
              v-if="currentStep < 2"
              src="../assets/images/logo.png"
              alt="logo"
              class="logo-image"
            />
            <img
              v-else
              src="../assets/images/logoThird.png"
              alt="logo"
              class="logo-image"
            />
          </div>
        </div>
      </div>

      <!-- 界面切换动画 -->
      <Transition name="slide-fade">
        <!-- 界面1和界面2：上传头像和选择城市 -->
        <div v-if="currentStep < 2" class="main-content">
          <!-- 上传头像区域 -->
          <div class="upload-section">
            <div class="upload-card" @click="handleAvatarUpload">
              <div
                class="avatar-upload"
                :class="{ 'has-avatar': avatarUrl }"
              >
                <template v-if="avatarUrl">
                  <img :src="avatarUrl" alt="头像" class="avatar-image" />
                  <!-- <div class="upload-success">
                  <svg class="check-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3">
                    <path d="M5 13l4 4L19 7" />
                  </svg>
                </div> -->
                </template>
                <template v-else>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                  >
                    <path
                      d="M14 10V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V10"
                      stroke="#4477F9"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M11.3307 5.33333L7.9974 2L4.66406 5.33333"
                      stroke="#4477F9"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                    <path
                      d="M8 2V10"
                      stroke="#4477F9"
                      stroke-width="1.33333"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                  <span class="upload-text">上传</span>
                </template>
              </div>
              <div class="upload-info">
                <template v-if="avatarUrl">
                  <div class="upload-status-row">
                    <img
                      src="../assets/images/container.png"
                      alt="check"
                      class="check-circle"
                    />
                    <span class="upload-status success">头像已上传</span>
                  </div>
                  <p class="upload-hint">点击更换头像</p>
                </template>
                <template v-else>
                  <p class="upload-status"><span class="spec">Step1：</span>上传你的真实头像</p>
                  <p class="upload-hint">点击左侧圆圈上传照片</p>
                  <p class="upload-format">支持 JPG / PNG 格式</p>
                </template>
              </div>
              <Transition name="scale-fade">
                <div
                  v-show="selectedCity"
                  :key="selectedCity?.id"
                  class="edit-btn"
                >
                  <img
                    :src="selectedCity?.emoji"
                    alt="城市图片"
                    class="city-image"
                  />
                </div>
              </Transition>
            </div>
          </div>

          <!-- 选择城市区域 -->
          <div class="city-section">
            <div class="section-header">
              <div class="section-line"></div>
              <span class="section-title"><span class="spec">Step2：</span>选择你代表的城市</span>
            </div>
            <div class="city-grid">
              <div
                v-for="city in cities"
                :key="city.id"
                class="city-item"
                :class="{ selected: selectedCity?.id === city.id }"
                @click="selectCity(city)"
              >
                <div
                  class="city-image-wrapper"
                  
                >
                  <img :src="city.emoji" alt="城市图片" class="city-image" />
                </div>
                <span class="city-name">{{ city.name }}</span>
                <div
                  v-if="selectedCity?.id === city.id"
                  class="selected-ring"
                ></div>
              </div>
            </div>
          </div>

          <!-- 底部按钮 -->
          <div class="button-container">
            <button
              class="generate-btn"
              :class="{ disabled: !canGenerate }"
              @click="generateCard"
            >
              Setp3：立即生成
            </button>
          </div>
        </div>

        <!-- 界面3：生成卡片展示 -->
        <div v-else class="card-preview">
          <div class="card-container">
            <div class="generated-card">
              <img 
                v-if="mergedCardUrl" 
                :src="mergedCardUrl" 
                alt="生成的卡片" 
                class="merged-card-image"
              />
              <img 
                v-else-if="cardResultUrl" 
                :src="cardResultUrl" 
                alt="生成的卡片" 
                class="merged-card-image"
              />
            </div>
          </div>
          <div class="tips" v-if="isWeixin">长按图片保存</div>
          <div class="tips" v-else>点击按钮保存图片</div>
          <div class="preview-buttons">
            <button class="action-btn secondary" @click="reset">
             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
<path d="M2 8C2 6.4087 2.63214 4.88258 3.75736 3.75736C4.88258 2.63214 6.4087 2 8 2C9.67737 2.00631 11.2874 2.66082 12.4933 3.82667L14 5.33333" stroke="#475466" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M13.9974 2V5.33333H10.6641" stroke="#475466" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14 8C14 9.5913 13.3679 11.1174 12.2426 12.2426C11.1174 13.3679 9.5913 14 8 14C6.32263 13.9937 4.71265 13.3392 3.50667 12.1733L2 10.6667" stroke="#475466" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M5.33333 10.666H2V13.9993" stroke="#475466" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
              重新生成
            </button>
            <button class="action-btn primary" @click="saveCard" v-if="!isWeixin">
              <svg
                class="btn-icon"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
                <polyline points="7 10 12 15 17 10" />
                <line x1="12" y1="15" x2="12" y2="3" />
              </svg>
              保存卡片
            </button>
          </div>
        </div>
      </Transition>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from "vue";
import Spinner from "@ventralnet/vue3-spinkit";
import gz from "@/assets/images/gz.png";
import sz from "@/assets/images/sz.png";
import zh from "@/assets/images/zh.png";
import fs from "@/assets/images/fs.png";
import zs from "@/assets/images/zs.png";
import jm from "@/assets/images/jm.png";
import yf from "@/assets/images/yf.png";
import st from "@/assets/images/st.png";
import hz from "@/assets/images/hz.png";
import cz from "@/assets/images/cz.png";
import jy from "@/assets/images/jy.png";
import hy from "@/assets/images/hy.png";
import yj from "@/assets/images/yj.png";
import zq from "@/assets/images/zq.png";
import sg from "@/assets/images/sg.png";
import mz from "@/assets/images/mz.png";
import sw from "@/assets/images/sw.png";
import dg from "@/assets/images/dg.png";
import zj from "@/assets/images/zj.png";
import mm from "@/assets/images/mm.png";
import qy from "@/assets/images/qy.png";
import bg1 from "@/assets/images/bg1.png";
import { debugApi } from '@/api/index';
import actionEvent from "@/utils/actionEvent.js";
import { up2OSSByPreSignUrl } from '@/api/oss/alioss.js'
import { ossUploadType } from '@/utils/constants.js'
import { showSuccessToast, showFailToast } from 'vant'
import request from "@/utils/request.js";

interface City {
  id: number;
  name: string;
  emoji: string;
  color: string;
  slogan: string;
  cheer: string;
}

const cities = ref<City[]>([
  {
    id: 1,
    name: "广州",
    emoji: gz,
    color: "linear-gradient(135deg, #FF6B6B 0%, #EE5A5A 100%)",
    slogan: "花城广州",
    cheer: "广州队，掂过碌蔗",
  },
  {
    id: 2,
    name: "深圳",
    emoji: sz,
    color: "linear-gradient(135deg, #4ECDC4 0%, #44A08D 100%)",
    slogan: "鹏城深圳",
    cheer: "深圳速度，势不可挡",
  },
  {
    id: 3,
    name: "珠海",
    emoji: zh,
    color: "linear-gradient(135deg, #45B7D1 0%, #2980B9 100%)",
    slogan: "浪漫之城",
    cheer: "珠海珠海，靓到爆棚",
  },
  {
    id: 4,
    name: "汕头",
    emoji: st,
    color: "linear-gradient(135deg, #F39C12 0%, #E67E22 100%)",
    slogan: "鮀城汕头",
    cheer: "汕头加油，胶己人撑你",
  },
  {
    id: 5,
    name: "佛山",
    emoji: fs,
    color: "linear-gradient(135deg, #9B59B6 0%, #8E44AD 100%)",
    slogan: "武术之乡",
    cheer: "佛山无影脚，赢波无对手",
  },
  {
    id: 6,
    name: "韶关",
    emoji: sg,
    color: "linear-gradient(135deg, #1ABC9C 0%, #16A085 100%)",
    slogan: "无敌韶关",
    cheer: "韶关队，顶硬上",
  },
  {
    id: 7,
    name: "湛江",
    emoji: zj,
    color: "linear-gradient(135deg, #3498DB 0%, #2980B9 100%)",
    slogan: "港城湛江",
    cheer: "湛江劲揪，赢到漏油",
  },
  {
    id: 8,
    name: "肇庆",
    emoji: zq,
    color: "linear-gradient(135deg, #E74C3C 0%, #C0392B 100%)",
    slogan: "砚都肇庆",
    cheer: "肇庆好嘢，势如破竹",
  },
  {
    id: 9,
    name: "江门",
    emoji: jm,
    color: "linear-gradient(135deg, #2ECC71 0%, #27AE60 100%)",
    slogan: "中国侨都",
    cheer: "江门侨乡，踢出精彩",
  },
  {
    id: 10,
    name: "茂名",
    emoji: mm,
    color: "linear-gradient(135deg, #FF6B9D 0%, #FF8E53 100%)",
    slogan: "南方油城",
    cheer: "茂名雄起，势不可挡",
  },
  {
    id: 11,
    name: "惠州",
    emoji: hz,
    color: "linear-gradient(135deg, #5DADE2 0%, #3498DB 100%)",
    slogan: "惠民之州",
    cheer: "惠州队，好犀利",
  },
  {
    id: 12,
    name: "梅州",
    emoji: mz,
    color: "linear-gradient(135deg, #E67E22 0%, #D35400 100%)",
    slogan: "足球之乡",
    cheer: "梅州足球，威震四方",
  },
  {
    id: 13,
    name: "汕尾",
    emoji: sw,
    color: "linear-gradient(135deg, #AED6F1 0%, #85C1E9 100%)",
    slogan: "善美汕尾",
    cheer: "汕尾加油，乘风破浪",
  },
  {
    id: 14,
    name: "河源",
    emoji: hy,
    color: "linear-gradient(135deg, #74B9FF 0%, #0984E3 100%)",
    slogan: "客家古邑",
    cheer: "河源队，硬颈精神",
  },
  {
    id: 15,
    name: "阳江",
    emoji: yj,
    color: "linear-gradient(135deg, #6C5CE7 0%, #5B4CDB 100%)",
    slogan: "中国刀都",
    cheer: "阳江队，锋利无比",
  },
  {
    id: 16,
    name: "清远",
    emoji: qy,
    color: "linear-gradient(135deg, #FDCB6E 0%, #F39C12 100%)",
    slogan: "凤城清远",
    cheer: "清远清远，清远威",
  },
  {
    id: 17,
    name: "中山",
    emoji: zs,
    color: "linear-gradient(135deg, #FFEAA7 0%, #FDCA40 100%)",
    slogan: "伟人故里",
    cheer: "一鸽胜九鸡，中山够晒威",
  },
  {
    id: 18,
    name: "东莞",
    emoji: dg,
    color: "linear-gradient(135deg, #E17055 0%, #D63031 100%)",
    slogan: "世界工厂",
    cheer: "东莞制造，品质保证",
  },
  {
    id: 19,
    name: "潮州",
    emoji: cz,
    color: "linear-gradient(135deg, #DDA0DD 0%, #BA55D3 100%)",
    slogan: "海滨邹鲁",
    cheer: "潮州队，胶己人",
  },
  {
    id: 20,
    name: "揭阳",
    emoji: jy,
    color: "linear-gradient(135deg, #81ECEC 0%, #00CEC9 100%)",
    slogan: "粤东新城",
    cheer: "揭阳揭阳，越来越好",
  },
  {
    id: 21,
    name: "云浮",
    emoji: yf,
    color: "linear-gradient(135deg, #DFE6E9 0%, #B2BEC3 100%)",
    slogan: "石都云浮",
    cheer: "云浮云浮，云中飞",
  },
]);

const screenRatio = ref<"standard" | "long" | "wide">("standard");
const currentStep = ref(0);
const avatarUrl = ref("");
const selectedCity = ref<City | null>(null);
const isLoading = ref(false);
const avatarOssUrl = ref('')
const cityTemplatePk = ref('')
const taskId = ref('')
const cardResultUrl = ref('')
const mergedCardUrl = ref('')

// 音乐播放相关
const isMusicPlaying = ref(false);
let audio: HTMLAudioElement | null = null;

const containerClass = computed(() => `screen-${screenRatio.value}`);

// Canvas合并两张图片
const mergeImages = async (baseUrl: string, overlayUrl: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    const baseImg = new Image();
    const overlayImg = new Image();
    
    // 允许跨域
    baseImg.crossOrigin = 'anonymous';
    overlayImg.crossOrigin = 'anonymous';
    
    let baseLoaded = false;
    let overlayLoaded = false;
    
    const checkComplete = () => {
      if (baseLoaded && overlayLoaded) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        
        if (!ctx) {
          reject(new Error('无法创建Canvas上下文'));
          return;
        }
        
        // 设置canvas尺寸为图片尺寸
        canvas.width = baseImg.width;
        canvas.height = baseImg.height;
        
        // 绘制底图
        ctx.drawImage(baseImg, 0, 0);
        
        // 绘制水印图（盖在上面）
        ctx.drawImage(overlayImg, 0, 0);
        
        // 转换为base64
        const mergedUrl = canvas.toDataURL('image/png');
        resolve(mergedUrl);
      }
    };
    
    baseImg.onload = () => {
      baseLoaded = true;
      console.log('底图加载完成:', {
        width: baseImg.width,
        height: baseImg.height,
        url: baseUrl,
        isBase64: baseUrl.startsWith('data:image/')
      });
      checkComplete();
    };
    
    baseImg.onerror = () => {
      console.error('无法加载底图:', baseUrl);
      reject(new Error('无法加载底图'));
    };
    
    overlayImg.onload = () => {
      overlayLoaded = true;
      console.log('水印图加载完成:', {
        width: overlayImg.width,
        height: overlayImg.height,
        url: overlayUrl,
        isBase64: overlayUrl.startsWith('data:image/')
      });
      checkComplete();
    };
    
    overlayImg.onerror = () => {
      console.error('无法加载水印图:', overlayUrl);
      reject(new Error('无法加载水印图'));
    };
    
    console.log('开始加载图片:', {
      baseUrl: baseUrl.substring(0, 100) + (baseUrl.length > 100 ? '...' : ''),
      overlayUrl: overlayUrl.substring(0, 100) + (overlayUrl.length > 100 ? '...' : '')
    });
    
    baseImg.src = baseUrl;
    overlayImg.src = overlayUrl;
  });
};

const canGenerate = computed(() => {
  return avatarUrl.value && selectedCity.value;
});

const calculateScreenType = (): "standard" | "long" | "wide" => {
  const viewportWidth = window.innerWidth;
  const viewportHeight = window.innerHeight;
  const aspectRatio = viewportWidth / viewportHeight;
  const designRatio = 390 / 753;

  if (aspectRatio < designRatio - 0.02) {
    return "long";
  } else if (aspectRatio > designRatio + 0.02) {
    return "wide";
  } else {
    return "standard";
  }
};

const handleResize = () => {
  screenRatio.value = calculateScreenType();
  setVH();
};

const selectCity = (city: City) => {
  selectedCity.value = city;
};

const handleAvatarUpload = () => {
  const input = document.createElement("input");
  input.type = "file";
  input.accept = "image/jpeg,image/png";
  input.style.display = "none";
  
  // 添加到DOM中（iOS Safari必需）
  document.body.appendChild(input);
  
  input.onchange = async (e) => {
    const file = (e.target as HTMLInputElement).files?.[0];
    console.log(e);
    
    console.log('file', file)
    // 立即移除input
    document.body.removeChild(input);
    
    if (file) {
      // 限制图片大小不超过10MB
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        showFailToast("图片大小不能超过10MB");
        return;
      }

      // 1. 先本地预览图片
      const reader = new FileReader();
      reader.onload = (event) => {
        avatarUrl.value = event.target?.result as string;
      };
      reader.readAsDataURL(file);

      try {
        // 2. 调用接口上传图片
       const ossRes = await up2OSSByPreSignUrl(ossUploadType.avatarFile, file)
       console.log('ossUrl', ossRes)
       if(ossRes){
        showSuccessToast('头像上传成功')
        avatarOssUrl.value = ossRes
       }
      } catch (error) {
        showFailToast( error);
        // 如果上传失败，继续使用本地预览的base64图片
      }
    }
  };
  
  // 触发点击
  input.click();
};

const generateCard = async () => {
  if (canGenerate.value) {
    actionEvent("click");
    console.log('avatarOssUrl.value', avatarOssUrl.value)
    if(!avatarOssUrl.value){
      showFailToast('请上传头像')
      return
    }
    console.log(selectedCity.value)
    const encodedCity = encodeURIComponent(selectedCity.value?.name);
    const cityTemplateRes = await debugApi.getCityTemplate({
      cityName: encodedCity
    })
    if(cityTemplateRes.code === '200'){
      cityTemplatePk.value = cityTemplateRes.data?.templateList[0]. templatePk|| ''
    }else{
      showFailToast('获取城市模板失败')
      return
    }
    const submitRes = await debugApi.submitFusionPerson({
      sourceUrl: avatarOssUrl.value,
      templatePk: cityTemplatePk.value,
    })
    if(submitRes.code === '200'){
      console.log('submitRes', submitRes)
      taskId.value = submitRes.data?.taskId || ''
      isLoading.value = true;
      
      // 开启轮询查询任务状态
      startPolling(taskId.value);
      
    }else{
      showFailToast(submitRes.msg || '生成失败')
      return
    }
  }else{
    showFailToast("请按顺序执行操作!")
  }
};

// 轮询相关状态
let pollingTimer: ReturnType<typeof setInterval> | null = null;
const maxPollingTimes = 60; // 最大轮询次数
let currentPollingCount = 0;

// 开始轮询
const startPolling = (taskId: string) => {
  // 先清除之前的轮询
  stopPolling();
  
  currentPollingCount = 0;
  pollingTimer = setInterval(async () => {
    currentPollingCount++;
    
    try {
      const result = await debugApi.queryFusionResult({ taskId:taskId });
      if (result.code === '200') {
        const status = result.data?.status;
        const cardUrl = result.data?.resultUrl;
        
        console.log(`轮询第 ${currentPollingCount} 次, 状态: ${status}`);
        
        if (status === 2 && cardUrl) {
          // 任务成功完成
          stopPolling();
          
          const waterMarkUrl = result.data?.waterMarkUrl;
          
          if (waterMarkUrl) {
            // 使用Canvas合并两张图片
            try {
              const mergedUrl = await mergeImages(cardUrl, waterMarkUrl);
              mergedCardUrl.value = mergedUrl;
              isLoading.value = false;
              currentStep.value = 2; // 跳转到结果页面
            } catch (error) {
              console.error('图片合并失败:', error);
              // 如果合并失败，使用原始图片
              cardResultUrl.value = cardUrl;
              isLoading.value = false;
              currentStep.value = 2;
            }
          } else {
            // 如果没有水印图，直接使用原始图片
            cardResultUrl.value = cardUrl;
            isLoading.value = false;
            currentStep.value = 2;
          }
        } else if (status === 3) {
          // 任务失败
          stopPolling();
          isLoading.value = false;
          showFailToast(result.data?.failReason || '生成失败');
        } else if (status === 'processing') {
          // 任务处理中，继续轮询
          console.log('任务处理中...');
        }
      }else{
        showFailToast(result.message || '生成失败')
      }
      
      // 超过最大轮询次数，停止轮询
      if (currentPollingCount >= maxPollingTimes) {
        stopPolling();
        isLoading.value = false;
        showFailToast('请求超时，请重试');
      }
    } catch (error) {
      console.error('轮询失败:', error);
      currentPollingCount++;
      
      if (currentPollingCount >= maxPollingTimes) {
        stopPolling();
        isLoading.value = false;
        showFailToast('请求超时，请重试');
      }
    }
  }, 2000); // 每2秒轮询一次
};

// 停止轮询
const stopPolling = () => {
  if (pollingTimer) {
    clearInterval(pollingTimer);
    pollingTimer = null;
  }
};

const reset = () => {
  currentStep.value = 0;
  avatarUrl.value = "";
  selectedCity.value = null;
};

const saveCard = () => {
  if (!mergedCardUrl.value) {
    showFailToast("没有可保存的图片！");
    return;
  }
  ycpsave(mergedCardUrl.value)
};

// 客户端保存
const ycpsave = (item) => {
  const params = {
    action: "appSaveImage",
    data: mergedCardUrl.value
  };

  if (window.ycp) {
    window.ycp.postMessage(JSON.stringify(params));
  }
};

// js动态计算适配
const setVH = () => {
  let vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

// 浏览器环境检测
const isWeixin = computed(() => {
  const ua = navigator.userAgent.toLowerCase();
  return ua.indexOf('micromessenger') !== -1;
});

onMounted(() => {
  console.log('视口宽度:', window.innerWidth);
console.log('视口高度:', window.innerHeight);
  // isLoading.value = true;
  // .value = 2;currentStep
  actionEvent("view");
  screenRatio.value = calculateScreenType();
  window.addEventListener("resize", handleResize);
});

onUnmounted(() => {
  window.removeEventListener("resize", handleResize);
});
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  /* 使用 JS 注入的变量 */
  height: calc(var(--vh, 1vh) * 100);
  background-image: url("../assets/images/bg.png");
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .top-pic {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 271px;
    object-fit: cover;
  }

  .all-content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding-bottom: 24px;
    display: flex;
    flex-direction: column;
  }
}

// .screen-wide {
//   .button-container, .preview-buttons {
//     bottom: 60px;
//   }
// }

// .screen-long {
//   .button-container, .preview-buttons {
//     bottom: 80px;
//   }
// }

/* 红框3：顶部区域使用titlePic.png背景图 */
.header-bg {
  width: 100%;
  height: auto;
  padding: 24px 0 10px 0;
  margin: 0 auto;
}

.header-content {
  display: flex;
  align-items: center;
}

.logo-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.logo-image {
  width: 100%;
  height: 137px;
  object-fit: contain;
}

.league-name {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.9);
  margin: 8px 0 4px;
}

.desc-text {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.7);
  margin: 0;
}

/* 红框1/8：底部按钮固定，中间区域可滚动 */
.main-content {
  padding: 0 20px;
  overflow: hidden;
  position: relative;
  flex: 1;
  // height: calc(100dvh - 171px);
  // padding-bottom: 100px;
}

/* 红框4：上传区域改为左右布局 */
.upload-section {
  margin-bottom: 10px;
 border-radius: 16px;
// border: 2px solid var(--linear-2-paints, #2A1FAF);
background: #FFF;
}

.upload-card {
  background: #ffffff;
  border-radius: 16px;
  padding: 12px 16px;
  padding-right: 70px;
  border-radius: 16px;
  border: 2px solid transparent;
  background: linear-gradient(#ffffff, #ffffff) padding-box,
              linear-gradient(97deg, rgba(51, 149, 243, 1) 0%, rgba(135, 132, 247, 1) 100%) border-box;
  position: relative;
  display: flex;
  align-items: center;
  gap: 14px;
  height: 100px;
}

.avatar-upload {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  border: 1.778px dashed rgba(68, 119, 249, 0.35);
  background: rgba(68, 119, 249, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;

  &:active {
    transform: scale(0.95);
  }

  &.has-avatar {
     border: 2px solid transparent;
  background: linear-gradient(#ffffff, #ffffff) padding-box,
              linear-gradient(97deg, rgba(51, 149, 243, 1) 0%, rgba(135, 132, 247, 1) 100%) border-box;
  }
}

.avatar-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.upload-success {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 24px;
  height: 24px;
  background: #67c23a;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 3px solid #ffffff;
}

.check-icon {
  width: 14px;
  height: 14px;
  color: #ffffff;
}

.upload-icon {
  width: 24px;
  height: 24px;
  color: #999999;
}

.upload-text {
  color: #4477f9;
  text-align: center;
  font-family: "Alibaba PuHuiTi 3.0";
  font-size: 8px;
  font-style: normal;
  font-weight: 400;
  line-height: 12px; /* 150% */
  letter-spacing: 0.148px;
  margin-top: 2px;
}

.upload-info {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.upload-status-row {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
}

.check-circle {
  width: 16px;
  height: 16px;
  color: #67c23a;
}

.upload-status {
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  color: rgba(0, 0, 0, 0.75);
  font-family: "Alibaba PuHuiTi 3.0";
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  line-height: 21px; /* 150% */
  letter-spacing: -0.15px;
  .spec{
    color: #8784F7;
font-family: "Alibaba PuHuiTi 3.0";
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 21px; /* 150% */
letter-spacing: -0.15px;
  }

  &.success {
    color: #7088f6;
    font-family: "Alibaba PuHuiTi 3.0";
    font-size: 13px;
    font-style: normal;
    font-weight: 600;
    line-height: 19.5px; /* 150% */
    letter-spacing: -0.076px;
  }
}

.upload-hint {
  font-size: 12px;
  color: #999999;
  margin: 0 0 4px;
  color: rgba(0, 0, 0, 0.38);
  font-family: "Alibaba PuHuiTi 3.0";
  font-size: 11px;
  font-style: normal;
  font-weight: 700;
  line-height: 16.5px; /* 150% */
  letter-spacing: 0.064px;
}

.upload-format {
  font-size: 11px;
  color: #cccccc;
  margin: 0;
  color: rgba(0, 0, 0, 0.25);
  font-family: "Alibaba PuHuiTi 3.0";
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
  line-height: 15px; /* 150% */
  letter-spacing: 0.117px;
}

/* 红框6：已上传头像的编辑按钮 */
.edit-btn {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 70.5px;
  border-radius: 8px;
  overflow: hidden;
  opacity: 1;
  visibility: visible;

  &.scale-fade-enter-active,
  &.scale-fade-leave-active {
    transition: opacity 0.2s ease, visibility 0.2s ease, transform 0.2s ease;
  }

  &.scale-fade-enter-from,
  &.scale-fade-leave-to {
    opacity: 0;
    visibility: hidden;
    transform: translateY(-50%) scale(0.8);
  }

  &.scale-fade-leave-from {
    opacity: 1;
    visibility: visible;
    transform: translateY(-50%) scale(1);
  }

  .city-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 8px;
    // border-top-left-radius: 11px;
    // border-top-right-radius: 11px;
  }
}

.city-section {
  height: calc(100% - 182px);
  overflow-y: auto;
  padding-bottom: 0;
}

.section-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 14px;
}

.section-line {
  width: 4px;
  height: 16px;
  background:
    linear-gradient(176deg, #3395f3 0%, #8784f7 65%),
    linear-gradient(
      97deg,
      #2a1faf 7.52%,
      #bb4abb 68.01%,
      #cb6ec0 81.08%,
      #f4cfcd 115.98%
    );
  border-radius: 2px;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #333333;
  .spec{
    color: #8784F7;
font-family: "Alibaba PuHuiTi 3.0";
font-size: 14px;
font-style: normal;
font-weight: 700;
line-height: 21px; /* 150% */
letter-spacing: -0.15px;
  }
}

.section-count {
  font-size: 11px;
  color: #999999;
  margin-left: auto;
}

.city-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

/* 红框2：city-item宽比高长、添加阴影、调整字体大小 */
.city-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  // padding: 8px 8px;
  background: #f8f9fa;
  border-radius: 15px;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  width: calc((100% - 20px) / 3);
  border: 3px solid transparent;
  box-sizing: border-box;
  height: 140px;
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.08);

  &:active {
    transform: scale(0.96);
  }
}

.city-image-wrapper {
  width: 100%;
  height: 100%;
  border-radius: 12px;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  background: #fff;
}

.city-item.selected {
  background: linear-gradient(#f8f9fa, #f8f9fa) padding-box,
              linear-gradient(97deg, rgba(51, 149, 243, 1) 0%, rgba(135, 132, 247, 1) 100%) border-box;
}

.city-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 8px;
  background: url(<path-to-image>) lightgray 50% / cover no-repeat;
}

.city-name {
  font-size: 14px;
  color: #ffffff;
  font-weight: 600;
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
  z-index: 10;
  width:100%;
  height: 30px;
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;

  text-align: center;
  background: linear-gradient(180deg, rgba(0, 0, 0, 0.00) 0%, rgba(0, 0, 0, 0.40) 100%);
}

.selected-ring {
  position: absolute;
  top: 0;
  right: 0;
  width: 24px;
  height: 24px;
  background-image: url("@/assets/images/badge.png");
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  display: flex;
  align-items: center;
  justify-content: center;

  &::after {
    content: "";
    display: block;
    width: 10px;
    height: 5px;
    border-left: 2.5px solid #ffffff;
    border-bottom: 2.5px solid #ffffff;
    transform: rotate(-45deg);
    margin-bottom: 4px;
    margin-left: 4px;
  }
}

/* 红框1/8：底部按钮固定 */
.button-container {
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  z-index: 100;
}

.generate-btn {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 23px;
  font-size: 15px;
  font-weight: 600;
  color: #ffffff;
  background: var(
    --linear-2-paints,
    linear-gradient(90deg, #3395f3 0%, #8784f7 65%),
    linear-gradient(
      97deg,
      #2a1faf 7.52%,
      #bb4abb 68.01%,
      #cb6ec0 81.08%,
      #f4cfcd 115.98%
    )
  );
  box-shadow: 0 2px 32px 0 rgba(0, 184, 148, 0.12);

  cursor: pointer;
  transition: all 0.3s ease;

  &:active {
    transform: scale(0.98);
  }

  &.disabled {
    background: rgba(0, 0, 0, 0.07);
    color: rgba(0, 0, 0, 0.25);
    box-shadow: none;
    cursor: not-allowed;
  }
}

.card-preview {
  flex: 1;
  padding: 0 16px;
  overflow-y: auto;
  padding-bottom: 0;
  height: calc(100% - 161px);
  position: relative;
  margin-top:-30px
}

.preview-header {
  text-align: center;
  margin-bottom: 16px;
}

.preview-title {
  font-size: 18px;
  font-weight: bold;
  color: #ffffff;
  margin: 0 0 6px;
}

.preview-hint {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  margin: 0;
}

.card-container {
  display: flex;
  justify-content: center;
  width: 229px;
  height: 450px;
  margin: 0 auto;
  margin-top: 8px;

}

.tips{
  width: 100%;
  text-align: center;
  font-family: "Alibaba PuHuiTi 3.0";
  font-size: 14px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  letter-spacing: -0.454px;
  background: var(--linear-2-paints, linear-gradient(97deg, #2A1FAF 7.52%, #BB4ABB 68.01%, #CB6EC0 81.08%, #F4CFCD 115.98%));
  background-clip: text;
-webkit-background-clip: text;
-webkit-text-fill-color: transparent;
margin-top: 10px;
}

.generated-card {
  width: 100%;
  max-width: 343px;
  background-color:  lightgray 50% / cover no-repeat;
  border-radius: 20px;
  overflow: hidden;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #fff;
}

.merged-card-image {
  width: 100%;
  height: auto;
  display: block;
}

.card-header {
  background: linear-gradient(135deg, #4a90e2 0%, #2e5c8a 100%);
  padding: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.card-mascot {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  background: linear-gradient(135deg, #ffe4e1 0%, #ffb6c1 100%);
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-title-group {
  display: flex;
  flex-direction: column;
}

.card-main-title {
  font-size: 14px;
  font-weight: bold;
  color: #ffffff;
  margin: 0;
}

.card-sub-title {
  font-size: 11px;
  color: #ffd700;
  margin: 0;
}

.card-year {
  margin-left: auto;
  font-size: 10px;
  color: rgba(255, 255, 255, 0.8);
}

.card-body {
  padding: 16px;
  position: relative;
  background: linear-gradient(180deg, #e8f5e9 0%, #c8e6c9 100%);
}

.cartoon-placeholder {
  width: 100%;
  height: 260px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.cartoon-placeholder svg {
  width: 100%;
  height: 100%;
}

.cartoon-image {
  width: 100%;
  height: 260px;
  object-fit: cover;
  border-radius: 12px;
}

.card-city-info {
  position: absolute;
  bottom: 24px;
  left: 24px;
  background: rgba(0, 0, 0, 0.6);
  padding: 5px 10px;
  border-radius: 14px;
}

.city-label {
  font-size: 11px;
  color: #ffffff;
  font-weight: 500;
}

.card-footer {
  background: linear-gradient(135deg, #2e7d32 0%, #1b5e20 100%);
  padding: 14px 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.card-slogan {
  flex: 1;
}

.slogan-text {
  font-size: 16px;
  font-weight: bold;
  color: #ffd700;
  margin: 0;
}

.card-logos {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 6px;
}

.logo-text {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.7);
}

.logo-divider {
  font-size: 9px;
  color: rgba(255, 255, 255, 0.4);
}

.qrcode-icon {
  width: 28px;
  height: 28px;
  margin-left: auto;
}

/* 红框8：底部按钮固定 */
.preview-buttons {
  position: absolute;
  bottom: 0;
  left: 16px;
  right: 16px;
  display: flex;
  gap: 14px;
  z-index: 100;
}

.action-btn {
  flex: 1;
  height: 46px;
  border: none;
  border-radius: 23px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;

  &:active {
    transform: scale(0.98);
  }

  &.primary {
   border-radius: 999px;
background: var(--linear-2-paints, linear-gradient(90deg, #3395F3 0%, #8784F7 65%), linear-gradient(97deg, #2A1FAF 7.52%, #BB4ABB 68.01%, #CB6EC0 81.08%, #F4CFCD 115.98%));
box-shadow: 0 2px 32px 0 rgba(0, 184, 148, 0.12);
color: white;

  }

  &.secondary {
    border-radius: 999px;
border: 1px solid rgba(0, 0, 0, 0.10);
background: rgba(0, 0, 0, 0.05);
color: black;

  }
}

.btn-icon {
  width: 16px;
  height: 16px;
}

// @media screen and (min-width: 400px) {
//   .container {
//     max-width: 375px;
//     margin: 0 auto;
//   }
// }

/* Loading界面样式 */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  height: calc(var(--vh, 1vh) * 100);
  background-image: url("../assets/images/bg.png");
  background-size: cover;
  background-position: center;
  position: relative;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  .top-pic {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 271px;
    object-fit: cover;
  }
}

.loading-content {
  flex:1;
  padding: 0 20px;
  overflow: hidden;
  position: relative;
  height: calc(100dvh - 171px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: -100px;
  gap: 4px;
}

.loading-mascot {
  width: 80px;
  height: 80px;
  animation: bounce 1.5s ease-in-out infinite;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.loading-spinner {
  width: 160px;
  height: 160px;
  position: relative;
  .sk-fade-in {
    width: 100%;
    height: 100%;
    color: #8784F7 !important;
  }
  .loading-image {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80px;
    height: 80px;
    border-radius: 50%;
    object-fit: cover;
  }
}

:deep(.ball-clip-rotate-multiple > div) {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  border-width: 4px;
  animation: rotate 1.3s ease-in-out 0s infinite;
}
:deep(.ball-clip-rotate-multiple > div:last-child) {
  left: 10%;
  top: 10%;
  width: 80%;
  height: 80%;
  border-top-color:#3395F3;
  border-bottom-color: #3395F3;
  border-width: 4px;
  animation-duration: 0.8s;
}

@keyframes rotate {
  0% {transform: rotate(0deg) scale(1);}

  50% {
    transform: rotate(180deg) scale(.8);
}

100% {
    transform: rotate(1turn) scale(1);
}
}

.loading-text {
  font-size: 24px;
  font-weight: 600;
  color: #333333;
  margin: 0;
}

.loading-hint {
  font-size: 12px;
  color: #666666;
  margin: 0;
}

.loading-dots {
  display: flex;
  gap: 6px;
  margin-top: 10px;
}

.loading-dots .dot {
  width: 8px;
  height: 8px;
  background: #8784F7;
  border-radius: 50%;
  animation: dotPulse 1.2s ease-in-out infinite;

  &:nth-child(1) {
    animation-delay: 0s;
  }
  &:nth-child(2) {
    animation-delay: 0.2s;
  }
  &:nth-child(3) {
    animation-delay: 0.4s;
  }
  &:nth-child(4) {
    animation-delay: 0.6s;
  }
}

@keyframes dotPulse {
  0%,
  100% {
    opacity: 0.4;
    transform: scale(0.8);
  }
  50% {
    opacity: 1;
    transform: scale(1.2);
  }
}

/* 页面切换过渡动画 */
.slide-fade-enter-active,
.slide-fade-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-enter-from {
  opacity: 0;
  transform: translateX(30px);
}

.slide-fade-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

/* Loading界面过渡动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

/* 缩放淡入淡出动画 */
.scale-fade-enter-active,
.scale-fade-leave-active {
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.scale-fade-enter-from {
  opacity: 0;
  transform: scale(0.5);
}

.scale-fade-leave-to {
  opacity: 0;
  transform: scale(0.5);
}
@media (max-height: 620px) and (max-height: 88dvh){
  .header-bg {
    padding: 1vw 2.5vw 0px 2.5vw;
  }
  .bottom-bg {
    padding-bottom: calc(1.875vw + env(safe-area-inset-bottom));
  }
  .card-container {
    height: 96vw;
  }
}
@media (max-height: 700px)  {
  .header-bg {
    padding: 1vw 2.5vw 0px 2.5vw;
  }
  .bottom-bg {
    padding-bottom: calc(1.875vw + env(safe-area-inset-bottom));
  }
  .card-container {
    height: 96vw;
  }
}
@media (max-height: 900px) and (min-height: 840px) {
    .card-container{
      margin-top: 8vh;
    }
}
</style>
